/*
 * Copyright (c) Dito Technologies LLC
 */

import React, {Dispatch} from "react";
import {Action, State} from "ui/feature/root/FormReducer";
import styles from "./NoteFinderPage.module.scss"
import {createFragmentContainer} from "react-relay";
import NoteFinderPageOverlay from "ui/feature/root/note-select/NoteFinderPageOverlay";
import NoteFinderPageTools from "ui/feature/root/note-select/NoteFinderPageTools";
import {graphql} from "babel-plugin-relay/macro";
import {NoteFinderPage_sheet$data} from "ui/feature/root/note-select/__generated__/NoteFinderPage_sheet.graphql";

interface Props {
    sheet: NoteFinderPage_sheet$data;
    dispatch: Dispatch<Action>;
    state: State;
}

const NoteFinderPage: React.FC<Props> = ({state, dispatch, sheet}) => {
    return (
        <div className={styles.container}>
            <div>
                <NoteFinderPageTools
                    sheet={sheet}
                    className={styles.tools}
                    state={state}
                    dispatch={dispatch}
                />
                <NoteFinderPageOverlay
                    sheet={sheet}
                    state={state}/>
            </div>
            <img
                className={styles.img}
                alt={"Sheet Music Page"}
                src={sheet.thumbnail_download_url}
            />
        </div>
    )
}

export default createFragmentContainer(NoteFinderPage, {
    sheet: graphql`
    fragment NoteFinderPage_sheet on MusicSheet {
        id
        thumbnail_download_url
        ...NoteFinderPageOverlay_sheet
        ...NoteFinderPageTools_sheet
    }
    `
});
